import { Div, Button, Input } from '@codesuma/baseline'
import { LIST_ICONS, pickedIconUrl } from '../../configs/list-icons'
import { matchWords } from '../../utils/match-words'
import style from './index.module.css'

// A grid of icons, each with a word under it so a first-time user knows what
// it stands for, under a search box that matches labels and tags. Step 2 of
// the New List wizard, and the list page's "Change icon" sheet. `selected`
// starts on the list's current icon (or the one guessed from its name), so
// what they see is what they get. Emits 'pick' with the tapped icon's key.
export const IconPicker = (selected: string) => {
    const base = Div()
    base.addClass(style.base)

    const heading = Div('Pick an icon')
    heading.addClass(style.heading)

    const search = Input('Search, e.g. beach or gifts', 'text', { autocomplete: 'off' })
    search.addClass(style.search)
    search.attr('enterkeyhint', 'search')
    search.attr('autocorrect', 'off')
    search.on('input', ({ value }: { value: string }) => filter(value))
    // The grid is already filtered, so return only closes the keyboard.
    search.on('enter', () => search.blur())

    const empty = Div('No icon for that yet. Try another word.')
    empty.addClass(style.empty)

    const grid = Div()
    grid.addClass(style.grid)
    grid.attr('role', 'radiogroup')
    grid.attr('aria-label', 'Icon')

    const tiles = LIST_ICONS.map(({ key, label, tags }) => {
        const tile = Button()
        tile.addClass(style.tile)
        tile.attr('role', 'radio')

        // A CSS mask tinted with the page's text color, like the home circles.
        const picture = Div()
        picture.addClass(style.picture)
        picture.el.style.setProperty('--icon', `url(${pickedIconUrl(key)})`)

        const name = Div(label)
        name.addClass(style.label)

        tile.append(picture, name)
        tile.on('click', () => {
            select(key)
            base.emit('pick', key)
        })
        return { key, tile, words: ' ' + [label, ...tags].join(' ').toLowerCase() }
    })

    const select = (key: string) => tiles.forEach(t => {
        t.tile.toggleClass(style.selected, t.key === key)
        t.tile.attr('aria-checked', String(t.key === key))
    })
    select(selected)

    const filter = (query: string) => {
        let shown = 0
        tiles.forEach(t => {
            const show = matchWords(t.words, query)
            t.tile.toggleClass(style.hidden, !show)
            if (show) shown++
        })
        empty.toggleClass(style.hidden, shown > 0)
    }
    filter('')

    grid.append(...tiles.map(t => t.tile))
    base.append(heading, search, empty, grid)

    return base
}
